import styles from './OrderStatusBadge.module.css'

const STATUS_MAP: Record<string, { label: string; variant: string }> = {
    pending: { label: 'Pendiente', variant: 'warning' },
    confirmed: { label: 'Confirmado', variant: 'info' },
    printing: { label: 'En impresión', variant: 'info' },
    shipped: { label: 'Enviado', variant: 'primary' },
    delivered: { label: 'Entregado', variant: 'success' },
    cancelled: { label: 'Cancelado', variant: 'error' },
}

interface OrderStatusBadgeProps {
    status: string
}

export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
    const config = STATUS_MAP[status] || { label: status, variant: 'default' }

    return (
        <span className={`${styles.badge} ${styles[config.variant]}`}>
            {config.label}
        </span>
    )
}
